// @ts-strict-ignore
export const resizeImage = ({
  uri,
  width,
  height,
  compress,
  fileName,
  fileType,
}: {
  uri: string
  width: number
  height: number
  compress: number
  fileName: string
  fileType: 'image/jpeg' | 'image/gif' | 'image/png' | 'image/jpg'
}) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const img = new Image()

    if (!ctx) {
      reject(new Error('Could not get canvas context'))
      return
    }

    img.onload = () => {
      canvas.width = width
      canvas.height = height
      ctx.drawImage(img, 0, 0, width, height)

      canvas.toBlob(
        (blob: Blob) => {
          if (!blob) {
            reject(new Error('Failed to create blob'))
            return
          }

          const resizedFile = new File([blob], fileName, {
            type: fileType,
            lastModified: Date.now(),
          })

          const resizedUri = URL.createObjectURL(resizedFile)

          resolve({
            uri: resizedUri,
            width,
            height,
            file: resizedFile,
          })
        },
        fileType,
        compress
      )
    }

    img.onerror = () => reject(new Error('Failed to load image'))
    img.src = uri
  })
}

export const getImageDimensions = (file: File) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const uri = URL.createObjectURL(file)

    img.onload = function () {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
        uri,
      })
    }

    img.onerror = () => {
      URL.revokeObjectURL(uri)
      reject(new Error('Failed to get Width and height'))
    }

    img.src = uri
  })
}
